export default {
  karunaPoint: {},
};
